import ObserverCheckBox from './CheckBox';
export default ObserverCheckBox;
